var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMirrordark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 21 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "group-hover:fill-black transition-colors duration-300 w-3 h-3 lg:w-4 lg:h-4 xl:w-6 xl:h-6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.5C1 5.25329 5.2533 1 10.5 1V1C15.7467 1 20 5.25329 20 10.5V26H1V10.5Z",
    stroke: "black",
    fill: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirrordark);
export default __webpack_public_path__ + "static/media/mirrordark.1e020a9b9e3c23dd23434a6b9fb46ba1.svg";
export { ForwardRef as ReactComponent };